<template>
    <div>
        <navbar></navbar>
        <div class="__policybg">
            <div class="container">
                <p class="__bepro">Disclaimer</p>
            </div>
        </div><br>
        <div class="container">
            <div class="row">
                <div class="col-md-2 col-sm-2"></div>
                <div class="col-md-8 col-sm-8">
                    <p class="__term">We at <b>Findworka</b> are aware that some anonymous persons are posing as Findworka agents to defraud unsuspecting users.
                    Please note that Findworka is only placing Nigerian developers at the moment and will never charge our talents any
                    placement fees.</p>
                    
                    <p class="__term">To further protect yourself from these scammers, please keep the following tips in mind:</p>
                    <p class="__term">1. Findworka will never ask for any account password, and card details or money.</p>
                    <p class="__term">2. Findworka does not offer remote job services of any kind. Do not accept any emails or voice calls from anyone posing
                    as Findworka.</p>
                    <p class="__term">3. Findworka does not use Whatsapp to communicate with users. Our official communication channels are as follows:</p>
                    <p class="__term">Email: <a href="mailto:info@findworka.com"><b>info@findworka.com</b></a> & <a href="mailto:talent@findworka.com"><b>talent@findworka.com</b></a></p>
                    <p class="__term">Twitter: <a href="https://twitter.com/findworka" target="_blank"><b>@findworka</b></a></p>
                    <p class="__term">Instagram:<a href="https://www.instagram.com/findworka/" target="_blank"> <b>@findworka</b></a></p>
                    <p class="__term">Facebook: <a href="https://www.facebook.com/findworka" target="_blank"><b>@findworka</b></a></p>
                    <p class="__term">LinkedIn: <a href="https://www.linkedin.com/company/findworka/" target="_blank"><b>Findworka</b></a></p>
                    <p class="__term">Thank you as always</p>
                    <p class="__term">The Findworka Team</p>
                </div>
                <div class="col-md-2 col-sm-2"></div>
            </div>
        </div><br><br>

    </div>
</template>

<script>
import navbar from '../components/navbar';


export default {
    components: {
        navbar,
    },

    mounted() {
        $(document).ready(function () {
            $('.accordion').find('.accordion-toggle').click(function () {
                $(this).next().slideToggle('600');
                $(".accordion-content").not($(this).next()).slideUp('600');
            });
            $('.accordion-toggle').on('click', function () {
                $(this).toggleClass('active').siblings().removeClass('active');
            });
        });
    }
}
</script>

<style scoped>
.__bepro {
    font-size: 50px;
    font-weight: 600;
    line-height: 1.2;
    color: #ffffff;
}

.__term {
    font-size: 14px;
    line-height: 1.65;
    color: #000000;
    margin-top: 18px;
}

.accordion {
    width: 100%;
    margin: 0 auto;
}

.accordion-toggle {
    border-bottom: 1px solid #cccccc;
    cursor: pointer;
    margin: 0;
    padding: 20px 0;
    position: relative;
}

.accordion-toggle.active:after {
    content: "";
    position: absolute;
    right: 0;
    top: 17px;
    width: 0;
    height: 0;
    border-bottom: 5px solid #0000ef;
    border-left: 5px solid #fff;
    border-right: 5px solid #fff;
}

.accordion-toggle:before {
    content: "";
    position: absolute;
    right: 0;
    top: 25px;
    width: 0;
    height: 0;
    border-top: 5px solid #000;
    border-left: 5px solid #fff;
    border-right: 5px solid #fff;
}

.accordion-toggle.active:before {
    display: none;
}

.accordion-content {
    display: none;
    font-size: 16px;
    padding: 20px 0;
    text-align: justify;
}

.accordion-toggle.active {
    color: #0000ef;
}
</style>


// WEBPACK FOOTER //
// src/components/disclaimer.vue